<template>
  <div class="page" v-show="visible">
    <header>
      <header-player></header-player>
      <slot name="header"></slot>
    </header>
    <main>
      <slot></slot>
    </main>
    <footer>
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<style lang="less">
.page {
  position: fixed;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
main {
  flex: 1;
  overflow-y: auto;
}
</style>

<script>
export default {
  components: {
    'header-player': require('./HeaderPlayer.vue')
  },
  props: [
    'name'
  ],
  computed: {
    visible () {
      return this.name && this.$root.$routr && this.$root.$routr.name && this.$root.$routr.name === this.name
    }
  }
}
</script>
